import { ControlActivitiesEstimationParams } from "api/generated/model";
import { usePostTestingControlsControlActivitiesEstimation } from "api/generated/testing-controls/testing-controls";

export function useControlActivitiesEstimationQuery(
    params: ControlActivitiesEstimationParams,
    enabled = true
) {
    return usePostTestingControlsControlActivitiesEstimation(params, {
        query: {
            select: (response) => response.data,
            enabled: enabled && params.controlIds.length > 0,
        },
    });
}
